import React from 'react';
import { ClipboardCheck, Scale, Target } from 'lucide-react';

export const Process = () => {
  return (
    <div className="py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-white mb-12">
          Our Simple 3-Step Process
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: <ClipboardCheck className="w-12 h-12 text-primary" />,
              title: "1. Free Assessment",
              description: "Calculate your savings and get a personalized plan"
            },
            {
              icon: <Scale className="w-12 h-12 text-primary" />,
              title: "2. Legal Protection",
              description: "Our expert team handles all negotiations and paperwork"
            },
            {
              icon: <Target className="w-12 h-12 text-primary" />,
              title: "3. Debt Freedom",
              description: "Watch your debt decrease while keeping your assets safe"
            }
          ].map((step, index) => (
            <div key={index} className="text-center p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="flex justify-center mb-4">{step.icon}</div>
              <h3 className="text-xl font-semibold text-white mb-2">{step.title}</h3>
              <p className="text-gray-300">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};